// extracted by mini-css-extract-plugin
export var chevron = "_40-d";
export var disabled = "_40-b";
export var error = "_40-c";
export var hideBorder = "_40-1";
export var icon = "_40-e";
export var input = "_40-0";
export var large = "_40-f";
export var open = "_40-9";
export var placeholder = "_40-a";
export var regular = "_40-5";
export var singleRowInput = "_40-2";
export var singleSelectInput = "_40-3 _40-0";
export var small = "_40-4";
export var spinnerContainer = "_40-i";
export var tag = "_40-7";
export var tagsContainer = "_40-8";
export var tagsInput = "_40-6 _40-0";
export var xSmall = "_40-g";
export var xxSmall = "_40-h";